
const interests = [
    {
        id: 1,
        name: 'Gaming',
        src: './interests/gamepad.svg'
    },
    {
        id: 2,
        name: 'Photoshop',
        src: './interests/photoshop.svg'
    },
    {
        id: 3,
        name: 'Basketball',
        src: './interests/basketball-ball.svg'
    },
    {
        id: 4,
        name: 'Painting',
        src: './interests/brush.svg'
    },
    {
        id: 5,
        name: 'Music',
        src: './interests/headphones.svg'
    },
];

export default interests;